import type { PaletteOptions } from '@mui/material/styles';

export const lightPalette: PaletteOptions = {
  mode: 'light',
  primary: {
    main: '#E61645',
    light: '#FF6F8A',
    dark: '#C8123A',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#FAFAF8',
    paper: '#FFFFFF',
  },
  text: {
    primary: '#0A0A0A',
    secondary: '#404040',
    disabled: '#737373',
  },
  divider: '#E8E6E0',
  action: {
    active: '#E61645',
    hover: '#F4F4F1',
    selected: '#FCE6EC',
    focus: '#FCE6EC',
  },
  success: {
    main: '#16A34A',
  },
  warning: {
    main: '#EA580C',
  },
  error: {
    main: '#DC2626',
  },
  info: {
    main: '#2563EB',
  },
};

export const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    main: '#FF4869',
    light: '#FF6F8A',
    dark: '#E61645',
    contrastText: '#FFFFFF',
  },
  background: {
    default: '#0B1426',
    paper: '#171717',
  },
  text: {
    primary: '#FAFAFA',
    secondary: '#D4D4D4',
    disabled: '#A3A3A3',
  },
  divider: '#2E2E2E',
  action: {
    active: '#FF4869',
    hover: '#262626',
    selected: '#4A0815',
    focus: '#4A0815',
  },
  success: {
    main: '#16A34A',
  },
  warning: {
    main: '#EA580C',
  },
  error: {
    main: '#DC2626',
  },
  info: {
    main: '#2563EB',
  },
};
